import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MdClose, MdWarning } from 'react-icons/md';

import {
  startValidationRequest,
  closeValidationModal,
} from '~/store/modules/pickupValidation/actions';

import StepVerifyCourier from './steps/StepVerifyCourier';
import StepAwaitingDispatch from './steps/StepAwaitingDispatch';
import StepReleaseConfirm from './steps/StepReleaseConfirm';
import StepSupportBlock from './steps/StepSupportBlock';

import {
  Overlay,
  ModalBox,
  ModalHeader,
  ModalBody,
  StatusMessage,
  Button,
  ModalFooter,
} from './styles';

export default function PickupValidationModal({ cartId }) {
  const dispatch = useDispatch();
  const { validation, isModalOpen, loading } = useSelector(
    state => state.pickupValidation
  );

  useEffect(() => {
    if (isModalOpen && cartId) {
      dispatch(startValidationRequest(cartId));
    }
  }, [isModalOpen, cartId, dispatch]);

  const handleClose = useCallback(() => {
    dispatch(closeValidationModal());
  }, [dispatch]);

  const handleBoxClick = useCallback(e => {
    e.stopPropagation();
  }, []);

  if (!isModalOpen) {
    return null;
  }

  function renderAnomalyWarning() {
    return (
      <>
        <StatusMessage variant="warning">
          <MdWarning size={48} />
          <div className="title">Fluxo de validação interrompido</div>
          <div className="subtitle">
            O entregador iniciou a corrida sem que a validação de coleta fosse
            concluída.
            <br />
            <br />
            <strong>
              O fluxo de entrega não foi realizado de forma correta, este pedido
              não contará com o seguro de entrega.
            </strong>
          </div>
        </StatusMessage>

        <ModalFooter style={{ padding: '16px 0 0', border: 0 }}>
          <Button type="button" onClick={handleClose}>
            Entendi
          </Button>
        </ModalFooter>
      </>
    );
  }

  function renderStep() {
    if (loading || !validation) {
      return <p>Carregando dados do entregador...</p>;
    }

    switch (validation.status) {
      case 'pending':
      case 'failed':
        return <StepVerifyCourier cartId={cartId} />;
      case 'blocked':
        return <StepSupportBlock cartId={cartId} />;
      case 'awaiting_dispatch':
        return <StepAwaitingDispatch cartId={cartId} />;
      case 'dispatched':
        // Item 4: anomalia detectada — entregador acionou sem validação
        if (validation.skipped_validation) {
          return renderAnomalyWarning();
        }
        return <StepReleaseConfirm cartId={cartId} />;
      case 'released':
        return <StepReleaseConfirm cartId={cartId} released />;
      case 'canceled':
        return <StepReleaseConfirm cartId={cartId} released canceled />;
      default:
        return <StepVerifyCourier cartId={cartId} />;
    }
  }

  return (
    <Overlay onClick={handleClose}>
      <ModalBox onClick={handleBoxClick}>
        <ModalHeader>
          <h2>Validação de coleta</h2>
          <button type="button" onClick={handleClose}>
            <MdClose size={22} />
          </button>
        </ModalHeader>
        <ModalBody>{renderStep()}</ModalBody>
      </ModalBox>
    </Overlay>
  );
}
